// extracted by css-extract-rspack-plugin
export default {"inert":"_50ad9b48"};